import type AuthApiClient from "@tiendeo/auth/dist/AuthApi/AuthApiClient";
import TiendeoStatsClient, { getPlatform } from "@tiendeo/js-stats-client";
import type { Events } from "enums/EventEnum";
import Logger from "services/logger";

export class Analytics {
    public static Instance: Analytics;

    public static init(
        pageType: string,
        auth: AuthApiClient,
        tiendeoStatsClient: TiendeoStatsClient,
    ): void {
        if (this.Instance) {
            this.Instance.pageType = pageType;
            this.Instance.auth = auth;
            this.Instance.tiendeoStatsClient = tiendeoStatsClient;
            return;
        }

        this.Instance = new Analytics();
        this.Instance.pageType = pageType;
        this.Instance.auth = auth;
        this.Instance.tiendeoStatsClient = tiendeoStatsClient;
        this.Instance.logger = new Logger();

        document.addEventListener("click", this.Instance.clickEventListener.bind(this.Instance), {
            capture: true,
        });
    }

    private pageType: string = "";
    private logger: Logger;
    private auth: AuthApiClient;
    private tiendeoStatsClient: TiendeoStatsClient;

    private async clickEventListener(ev: MouseEvent) {
        const elementClicked: HTMLElement = ev.target as unknown as HTMLElement;

        if (!elementClicked || !elementClicked.dataset || !window || !window.navigator) return;

        const eventName = this.findEventName(elementClicked);

        if (!eventName) return;

        await this.sendEvent(eventName as Events);
    }

    private findEventName(elementClicked: HTMLElement) {
        if (elementClicked.dataset.event) {
            return elementClicked.dataset.event;
        }

        const parent = elementClicked.closest("[data-event]") as HTMLElement;
        if (!parent) {
            return null;
        }

        return parent.dataset.event;
    }

    async sendEvent(eventName: Events) {
        const eventPayload = {
            Action: "click",
            View: eventName,
            PageType: this.pageType,
            SearchType: "PROFILE",
            SearchWord: "profile",
            SearchCity: "no_city",
        };
        try {
            await this.tiendeoStatsClient.Event(
                "Page/Action",
                this.auth.GetUserId(),
                "",
                getPlatform(window.navigator.userAgent),
                eventPayload,
            );
        } catch (error) {
            this.logger.error(error);
        }
    }
}
